<template>
  <!--
    	作者：kmdshop
    	时间：2020-06-20
    	描述：diy组件-参数设置-商品栏
    -->
  <div>
    <div class="common-form">
      <span>{{ curItem.name }}</span>
    </div>
    <el-form size="small" :model="curItem" label-width="100px">
      <!-- <el-form-item label="显示数量：">
          <el-input v-model="curItem.params.showNum" class="w-auto"></el-input>
      </el-form-item> -->
      <template>
        <el-form-item label="供应商：">
          <el-cascader
            class="ww100"
            v-model="currSupply"
            v-if="SupplyList.length > 0"
            ref="cascader"
            :options="SupplyList"
            :props="{ checkStrictly: true, children: 'child', value: 'supply_id', label: 'name' }"
            @change="changeSupply"
            :visible="cascaderVisible" 
            @visible-change="handleVisibleChange"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="商品列表：">
          <div class="choice-product-list">
            <draggable v-model="curItem.data" :options = "{draggable:'.item',animation:500}">
              <transition-group class="d-s-c f-w">
                <div v-for="(product, index) in curItem.data" class="item" :key="product.product_id">
                  <div class="delete-box"><i class="el-icon-error" @click="$parent.onEditorDeleleData(index, selectedIndex)"></i></div>
                  <img :src="product.image" alt="" />
                </div>
              </transition-group>
            </draggable>
          </div>
          <div>
            <el-button icon="el-icon-plus" @click.stop="$parent.openProductZd(curItem.data,true,currSupply)">选择产品</el-button>
          </div>
        </el-form-item>
      </template>
      <!--组件样式-->
      <div class="p-10-0 mb16 f14 border-b"><span class="gray6">组件样式</span></div>

      <!-- 背景图片 -->
      <el-form-item label="背景图片：">
        <div class="d-s-c">
          <div class="bg-img-preview" style="width: 200px; height: 100px; border: 1px dashed #eee; display: flex; align-items: center; justify-content: center; margin-right: 10px;">
            <img 
              v-if="curItem.style && curItem.style.backgroundImage"
              :src="curItem.style.backgroundImage" 
              alt="背景图" 
              style="max-width: 100%; max-height: 100%;"
            >
            <span v-else class="text-gray-400">未选择图片</span>
          </div>
          
          <!-- 调用父组件选择图片的按钮 -->
          <el-button 
            type="primary" 
            size="small"
            @click="$parent.onEditorSelectImage(curItem.style, 'backgroundImage')"
          >
            选择图片
          </el-button>
          
          <!-- 移除图片按钮（有图时显示） -->
          <el-button 
            type="text" 
            size="small"
            style="margin-left: 10px;" 
            @click="curItem.style.backgroundImage = ''"
            v-if="curItem.style && curItem.style.backgroundImage"
          >
            移除
          </el-button>
        </div>
      </el-form-item>
      <!-- 商品排序 -->
      <el-form-item label="分列数量：">
          <el-radio-group v-model="curItem.style.column">
              <el-radio :label="1">单列</el-radio>
              <el-radio :label="2">两列</el-radio>
              <el-radio :label="3">三列</el-radio>
          </el-radio-group>
      </el-form-item>
      <!-- 商品排序 -->
      <el-form-item label="显示内容：">
          <el-checkbox v-model="curItem.style.show.productName">商品名称</el-checkbox>
          <el-checkbox v-model="curItem.style.show.productPrice">价格</el-checkbox>
          <el-checkbox v-model="curItem.style.show.linePrice">划线价格</el-checkbox>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import ProductApi from '@/api/product.js';
import draggable from 'vuedraggable';
export default {
  components: {
    draggable
  },
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*供应商列表*/
      SupplyList: [],
      /*当前选中的*/
      currSupply:[],
      productNameShow: false,
      productPriceShow: false,
      linePriceShow: false,
      sellingPointShow: false,
      productSalesShow: false,
      directCommissionShow:false,
      is_supply_check:false,
      cascaderVisible: false,
    };
  },
  props: ['curItem', 'selectedIndex', 'opts'],
  created() {
    if (!this.curItem.style) this.curItem.style = {};
    if (this.curItem.style.backgroundImage === undefined) {
      this.curItem.style.backgroundImage = ""; // 初始为空字符串
    }
    /*获取列表*/
    this.getData();
    this.productNameShow = this.curItem.style.show.productName == 1 ? true : false;
    this.productPriceShow = this.curItem.style.show.productPrice == 1 ? true : false;
    this.linePriceShow = this.curItem.style.show.linePrice == 1 ? true : false;
    this.directCommissionShow = this.curItem.style.show.directCommission == 1 ? true : false;
    this.sellingPointShow = this.curItem.style.show.sellingPoint == 1 ? true : false;
    this.productSalesShow = this.curItem.style.show.productSales == 1 ? true : false;

  },
  methods: {
    handleVisibleChange(val) {
      // val 为 true 表示下拉框展开，false 表示关闭
      this.cascaderVisible = val;
    },
    /*获取商品*/
    getData() {
      let self = this;
      ProductApi.supplyList(
        {
          page_id: self.page_id
        },
        true
      )
        .then(res => {
          let list = [];
          if(res.data.list.length>0){
            list = [
              {
                supply_id: 0,
                name: '全部',
              }
            ];
            res.data.list.forEach(item => {
              list.push(item);
            });
          }
          self.SupplyList = list;
          
          self.currSupply = self.currSupplyAuto(list);
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*选择默认*/
    currSupplyAuto(list){
      let arr=[];
      for(let i=0;i<list.length;i++){
        let item=list[i];
        if(item.supply_id==this.curItem.params.auto.supply){
          this.is_supply_check = true;
          arr.push(item.supply_id);
          return arr;
        }else{
          if (this.is_supply_check) {
            return arr;
          }
          if(Object.prototype.toString.call(item.child)== '[object Array]'&&item.child.length>0){
            arr.push(item.supply_id);
            let childs=this.currSupplyAuto(item.child);
            if(childs.length>0){
              arr=arr.concat(childs);
            }else{
              arr=[];
            }
          }
        }
      }
      return arr;
    },

    /*检查*/
    check(checked, name) {
      let value = checked ? 1 : 0;
      this.curItem.style.show[name] = value;
    },

    /*选择类别*/
    changeSupply(e) {
      const cascaderRef = this.$refs.cascader;
      if (!cascaderRef) return; // 避免 ref 不存在时报错

      // 获取选中的节点
      const checkedNodes = cascaderRef.getCheckedNodes();
      if (checkedNodes && checkedNodes.length > 0) {
        const supplyId = checkedNodes[0].data.supply_id;
        this.curItem.params.auto.supply = supplyId; // 保存选中的供应商ID
      }

      // 选择完成后，手动关闭下拉框
      this.cascaderVisible = false;
    }
  }
};
</script>

<style>
.choice-product-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.choice-product-list .item {
  position: relative;
  width: 80px;
  height: 80px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #dddddd;
}

.choice-product-list .item .delete-box {
  position: absolute;
  width: 20px;
  height: 20px;
  top: -10px;
  right: -10px;
  font-size: 20px;
  cursor: pointer;
  color: #999999;
}

.choice-product-list .item .delete-box:hover {
  color: rgb(255, 51, 0);
}

.choice-product-list .item.plus-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.choice-product-list .item.plus-btn > i {
  font-size: 30px;
  color: #cccccc;
}

.choice-product-list img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/page/page/diy/params/ProductZd.vue